import React from 'react';
import PayBillsEnterCodeFP from '../FullPagesComponents/Services/PayBillsEnterCodeFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import PayBillsScanBarcodeFP from '../FullPagesComponents/Services/PayBillsScanBarcodeFP';
import { Android } from '../../../utils/DictionaryManagementUtils';

//= ========================================================================
const PayBillsEnterCodeDF = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => {
  const { enable_customer_to_scan_barcode } = globJSON.configurations.services.pay_bills_0.select_bill;

  return (
    <SimulatorsViewerArrangement>
      {(simPlatform === Android && enable_customer_to_scan_barcode) ? (
        <PayBillsScanBarcodeFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
        />
      ) : (
        <PayBillsEnterCodeFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
        />
      )}
      {simPlatform === Android && enable_customer_to_scan_barcode && (
        <PayBillsScanBarcodeFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
          showPopup
        />
      )}
      {simPlatform === Android && (
        <PayBillsEnterCodeFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
        />
      )}
    </SimulatorsViewerArrangement>
  );
};

export default PayBillsEnterCodeDF;
